// 飞行模式
export default {
    'FM1': 'не летать',
    'FM2': 'Режим взлета',
    'FM3': 'Режим посадки',
    'FM4': 'Режим возврата',
    'FM5': 'Режим возврата исходного маршрута',
    'FM6': 'Режим отправлять в обратный рейс',
    'FM7': 'Режим упрвления',
    'FM8': 'Режим окружение',
    'FM9': 'Режим повышения устойчивости',
    'FM10': 'Режим заданной высоты',
    'FM11': 'Режим фиксированной точки',
    'FM12': 'Автоматический маршрут',
    'FM13': 'Режим точка AB ',
}